import UserContextValueProvider from "../../../Providers/Value/UserContextValueProvider";
import { IBaseDispositionConfirmationFormProps } from "../Components/ConfirmationModal/ConfirmationForm";
import OtherProceduresConfirmationForm, {
  IOtherProceduresConfirmationFormProps
} from "../Components/ConfirmationModal/OtherProceduresConfirmationForm";

/** Provisions the 'not offered procedure' options from the UserContext. */
const UserContextOtherProceduresConfirmationForm: React.FC<IBaseDispositionConfirmationFormProps> =
  UserContextValueProvider<
    Pick<IOtherProceduresConfirmationFormProps, "notOfferedProceduresOptions">,
    IOtherProceduresConfirmationFormProps
  >({
    Component: OtherProceduresConfirmationForm,
    map: ({ notOfferedProcedures }) => ({ notOfferedProceduresOptions: notOfferedProcedures })
  });

export default UserContextOtherProceduresConfirmationForm;
